import { css } from "styled-components";

var tooltipArrowStyle = function tooltipArrowStyle(_ref) {
  var position = _ref.position,
      theme = _ref.theme;
  var arrows = {
    top: css(["border-width:7px 7px 0 7px;border-color:", " transparent transparent transparent;"], theme.orbit.paletteBlueDark),
    right: css(["border-width:7px 7px 7px 0;border-color:transparent ", " transparent transparent;"], theme.orbit.paletteBlueDark),
    left: css(["border-width:7px 0 7px 7px;border-color:transparent transparent transparent ", ";"], theme.orbit.paletteBlueDark),
    bottom: css(["border-width:0 7px 7px 7px;border-color:transparent transparent ", " transparent;"], theme.orbit.paletteBlueDark)
  };
  return arrows[position];
};

export default tooltipArrowStyle;